<template>
    <div v-if="items.length > 0" class="panel col">
        <div class="row head">
            <span class="title">Travel Protection </span><span class="count">{{ items.length }} Protected</span>
        </div>
        <div class="row">
            <div class="col content">
                <div v-for="item, idx in items" :key="idx" class="row insurance">
                    <div class="name">{{ item.customerName }}</div>
                    <div class="price">{{ priceFormat(currencyStore.currentCurrency, item.insurancePrice,',',2,1) }}</div>
                </div>
            </div>
        </div>
        <div class="row footer" v-if="insuranceStore.unPayDisplay!=insuranceStore.unPay">
            <span class="title">Total Protection Price </span>
            <span class="title" style="display: flex;flex-direction: column;align-items: flex-end;">
                <span>{{ priceFormat('USD', insuranceStore.unPay,',',2,1) }}</span>            
                <span>({{ priceFormat(currencyStore.currentCurrency, insuranceStore.unPayDisplay,',',2,1) }})</span>
            </span>
        </div>
        <div class="row footer" v-else>
            <span class="title">Total Protection Price </span>
            <span class="title">
                {{ priceFormat(currencyStore.currentCurrency, insuranceStore.unPay,',',2,1) }}
            </span>
        </div>
    </div>
</template>
<style scoped lang="scss">
.panel {
    background-color: white;
    padding: 2rem 2.4rem;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.count {
    font-family: Poppins;
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2.2rem;
    text-align: left;
    color: #4F6F52;
}

.content {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.insurance {
    .name {
        font-family: Poppins;
        font-size: 1.4rem;
        font-weight: 500;
        line-height: 2.2rem;
        text-align: left;
        color: #666666;
        max-width: 60%;
    }

    .price {
        font-family: Poppins;
        font-size: 1.4rem;
        font-weight: 400;
        line-height: 2.2rem;
        text-align: left;
    }
}

.col {
    display: flex;
    flex-direction: column;
}

.row {
    display: flex;
    justify-content: space-between;
}

.title {
    font-family: Poppins;
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 2.2rem;
    text-align: left;
    color: #333333;
}
</style>
<script setup lang="ts">
import { useInsuranceStore } from '@/stores/InsuranceStore';
import { useCurrencyStore } from '@/stores/CurrencyStore';
import { reactive, computed } from 'vue';
import {priceFormat} from '@/utils/tool'

const insuranceStore = useInsuranceStore()
const currencyStore = useCurrencyStore()

function getName(last, first, middle) {
    const lastName = last != null ? last : ''
    const firstName = first != null ? first : ''
    const middleName = middle != null ? middle : ''
    return lastName + "/" + firstName + " " + middleName
}

const items = computed(() => {
    if (insuranceStore.quoteInfo == null || insuranceStore.quoteInfo.customers == null || insuranceStore.quoteInfo.customers.length == 0) {
        return []
    }
    const rows = insuranceStore.quoteInfo.customers.filter(c => c.accept == true).map((c) => {
        const quote = c.insuranceQuote
        return reactive({
            customer: c,
            invalid: false,
            accept: c.accept,
            customerName: getName(c.lastname, c.firstname, c.middlename),
            insurancePrice: quote ? (quote.individualPolicyCostDisplay ?? quote.individualPolicyCost) : null,
            tripPrice: quote ? (quote.individualTripCostDisplay ?? quote.individualTripCost) : null
        })
    })
    return rows
})

</script>